import * as React from 'react';
import { Image, StyleSheet, Text, Pressable, View, Share } from 'react-native';
import { AppContext } from "../context/AppContext";
import * as AppUtilities from "../context/AppUtilities";
import * as AppConstants from "../context/AppConstants";
import { CustomScrollView } from '../components/CustomScrollView';
import { CustomParagraph } from '../components/CustomParagraph';
import { Divider } from 'react-native-paper';

const styles = StyleSheet.create({
  socials: {
    paddingTop: 20,
  },
  socialsImage: {
    margin: 20,
    width: 25,
    height: 25,
  },
  wrapper: {
    flexDirection: "row",
    justifyContent: "center",
    flexWrap: "wrap",
    alignItems: "baseline"
  },
  centerHorizontally: {
    alignItems: "center",
  },
  certificationsWrapper: {
    flexDirection: "row",
    justifyContent: "center",
    flexWrap: "wrap",
    alignItems: "center",
  },
  certificationImage: {
    margin: 20,
  },
  image: {
    margin: 20,
  },
  appStoreImage1: {
    margin: 20,
    width: 170,
    height: 50,
  },
  boardImage: {
    margin: 20,
    width: 330,
    height: 330,
  },
  appStoreImage2: {
    margin: 20,
    width: 169,
    height: 50,
  },
  line: {
    paddingBottom: 25,
    flexShrink: 1,
  },
  line2: {
    paddingBottom: 5,
    flexShrink: 1,
  },
  label: {
    fontSize: 18,
    fontWeight: "bold",
    paddingBottom: 10,
    flexWrap: "wrap",
  },
  labelCenter: {
    fontSize: 22,
    fontWeight: "bold",
    paddingBottom: 10,
    flexWrap: "wrap",
    alignSelf: "center",
  },
  normal: {
    fontSize: 14,
    paddingRight: 10,
    flexWrap: "wrap",
  },
  nameTitle: {
    fontSize: 15,
    fontWeight: "bold",
  },
});

export function About({ navigation }) {
  const openShare = () => {
    Share.share(
      {
        message: AppConstants.HOMEPAGE_LINK,
        url: AppConstants.HOMEPAGE_LINK,
        title: "Find Humane",
      },
      {
        dialogTitle: "Share Find Humane",
        subject: "Find Humane",
      }
    );
  };

  return (
    <CustomScrollView>
      <View style={styles.line2}>
        <Text selectable={true} style={styles.labelCenter}>Mission Statement</Text>
      </View>
      <CustomParagraph selectable={true}>Find Humane's mission is to improve welfare for animals by providing services to people that consume animal products to find more humanely raised and slaughtered animal products.</CustomParagraph>
      <CustomParagraph style={AppConstants.STYLES.marginBottom10} selectable={true}>For more details, see our {AppUtilities.createInternalLink(navigation, "Frequently Asked Questions (FAQ)", AppConstants.SCREENS.FAQ)} page.</CustomParagraph>
      <Divider style={AppConstants.STYLES.marginVertical20} />
      <View style={styles.line2}>
        <Text selectable={true} style={styles.labelCenter}>Company</Text>
      </View>
      <CustomParagraph style={AppConstants.STYLES.marginBottom10} selectable={true}>Find Humane, Inc. is a Public Benefit Corporation incorporated in Delaware and based in New Braunfels, TX. Improving animal welfare is part of our corporate charter.</CustomParagraph>
      <Divider style={AppConstants.STYLES.marginVertical20} />
      <View style={styles.line2}>
        <Text selectable={true} style={styles.labelCenter}>Community</Text>
      </View>
      <CustomParagraph style={AppConstants.STYLES.marginBottom10} selectable={true}>Find Humane donates 20% of its profits every quarter to charities that have defined outcomes related to improving farmed animal welfare and using third-party screening (e.g. Guidestar, Charity Navigator) to ensure that recipient organizations are efficiently allocating resources.</CustomParagraph>
      <View style={styles.certificationsWrapper}>
        {
          //AppUtilities.createLink(<Image source={require('../../assets/Certified_B_Corporation_PENDING-SM_150_250.png')} style={styles.certificationImage} />, AppConstants.B_CORP_LINK)
        }
        {
          AppUtilities.createLink(<Image source={require('../../assets/aspca-grants-badge-2024_191x250.png')} style={styles.certificationImage} />, AppConstants.GRANT_LINK)
        }
        {
          AppUtilities.createLink(<Image source={require('../../assets/aspca-grants-badge-2023_191x250.png')} style={styles.certificationImage} />, AppConstants.GRANT_LINK_2023)
        }
      </View>
      <Divider style={AppConstants.STYLES.marginVertical20} />
      <View style={styles.line2}>
        <Text selectable={true} style={styles.labelCenter}>Connect</Text>
      </View>
      <View style={styles.centerHorizontally}><CustomParagraph style={AppConstants.STYLES.marginBottom10} selectable={true}>If you'd like to get in touch, {AppUtilities.createInternalLink(navigation, "contact us", AppConstants.SCREENS.MORE_CONTACT)}.</CustomParagraph></View>
      <View style={styles.socials}>
        <View style={styles.wrapper}>
          {
            !AppUtilities.isWeb() ?
                <Pressable onPress={openShare}>
                  <Image source={require('../../assets/share-black.png')} style={styles.socialsImage} />
                </Pressable>
              :
                null
          }
          {
            AppUtilities.createLink(<Image source={require('../../assets/facebook.png')} style={styles.socialsImage} />, AppConstants.FACEBOOK_LINK)
          }
          {
            AppUtilities.createLink(<Image source={require('../../assets/instagram.png')} style={styles.socialsImage} />, AppConstants.INSTAGRAM_LINK)
          }
          {
            AppUtilities.createLink(<Image source={require('../../assets/twitter.png')} style={styles.socialsImage} />, AppConstants.TWITTER_LINK)
          }
          {
            AppUtilities.createLink(<Image source={require('../../assets/rss.png')} style={styles.socialsImage} />, AppConstants.SUBSTACK_LINK)
          }
          {
            AppUtilities.isWeb() ?
                AppUtilities.createLink(<Image source={require('../../assets/email-send-outline-black.png')} style={styles.socialsImage} />, "mailto:?subject=" + encodeURIComponent("Find Humane") + "&body=" + encodeURIComponent("Check out more humanely raised animal-based products: " + AppConstants.HOMEPAGE_LINK))
              :
                null
          }
        </View>
      </View>
      <Divider style={AppConstants.STYLES.marginVertical20} />
      <View style={styles.line2}>
        <Text selectable={true} style={styles.labelCenter}>Download</Text>
      </View>
      <View style={styles.centerHorizontally}><CustomParagraph style={AppConstants.STYLES.marginBottom10} selectable={true}>Download our free app for your phone:</CustomParagraph></View>
      <View style={styles.wrapper}>
        {
          AppUtilities.createLink(<Image source={require('../../assets/appstore50.png')} style={styles.appStoreImage1} />, AppConstants.APPLE_STORE_LINK)
        }
        {
          AppUtilities.createLink(<Image source={require('../../assets/playstore50.png')} style={styles.appStoreImage2} />, AppConstants.ANDROID_STORE_LINK)
        }
      </View>
      <Divider style={AppConstants.STYLES.marginVertical20} />
      {
      /*<>
      <View style={styles.line}>
        <Text selectable={true} style={styles.labelCenter}>Board of Directors</Text>
      </View>
      <View style={styles.wrapper}>
        <View style={styles.centerHorizontally}>
          {
            AppUtilities.createLink(<Image source={require('../../assets/board/Kevin_Grigorenko.png')} style={styles.boardImage} />, "https://findhumane.com/")
          }
          <Text style={styles.nameTitle}>Kevin Grigorenko</Text>
          <Text>Founder</Text>
          <Text>{AppUtilities.createLink("Find Humane", "https://findhumane.com/")}</Text>
        </View>
        <View style={styles.centerHorizontally}>
          {
            AppUtilities.createLink(<Image source={require('../../assets/board/Allison_Molinaro.png')} style={styles.boardImage} />, "https://www.ciwf.org/")
          }
          <Text style={styles.nameTitle}>Allison Molinaro</Text>
          <Text>Campaigns Manager</Text>
          <Text>{AppUtilities.createLink("Compassion in World Farming", "https://www.ciwf.org/")}</Text>
        </View>
        <View style={styles.centerHorizontally}>
          {
            AppUtilities.createLink(<Image source={require('../../assets/board/Andrew_deCoriolis.png')} style={styles.boardImage} />, "https://www.farmforward.com/")
          }
          <Text style={styles.nameTitle}>Andrew deCoriolis</Text>
          <Text>Executive Director</Text>
          <Text>{AppUtilities.createLink("Farm Forward", "https://www.farmforward.com/")}</Text>
        </View>
        <View style={styles.centerHorizontally}>
          {
            AppUtilities.createLink(<Image source={require('../../assets/board/Harry_Rhodes.png')} style={styles.boardImage} />, "https://www.foodanimalconcernstrust.org/")
          }
          <Text style={styles.nameTitle}>Harry Rhodes</Text>
          <Text>Executive Director</Text>
          <Text>{AppUtilities.createLink("Food Animal Concerns Trust", "https://www.foodanimalconcernstrust.org/")}</Text>
        </View>
      </View>
      </>*/
      }
    </CustomScrollView>
  );
}
